import React from 'react';
import PropTypes from 'prop-types';
import SMStream from '../streams/SMStream2';

const smWidgets = ({ tournamentId = '', teamId = '', seasonId = '', playerId = '' }) => {
    return [
        {
            name: 'TeamSeasonFormSMWidget',
            props: {
                teamId,
                player1Id: playerId,
                player2Id: playerId,
                tournamentId,
                seasonId
            }
        },
        {
            name: 'H2HPlayerProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style1'
            }
        },
        {
            name: 'H2HPlayerProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style2'
            }
        },
        {
            name: 'H2HPlayerClubProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style1'
            }
        },
        {
            name: 'H2HPlayerClubProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style2'
            }
        },
        {
            name: 'H2HPlayerTournamentProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style1',
                ttIds: [tournamentId]
            }
        },
        {
            name: 'H2HPlayerTournamentProfileSMWidget',
            props: {
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style2',
                ttIds: [tournamentId]
            }
        },
        {
            name: 'H2HPlayerSeasonProfileSMWidget',
            props: {
                tournamentId,
                seasonId,
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style1',
                typeProfile: 'goals'
            }
        },
        {
            name: 'H2HPlayerSeasonProfileSMWidget',
            props: {
                tournamentId,
                seasonId,
                playerId,
                teamId,
                opponentId: playerId,
                opponentTeamId: teamId,
                typeStyle: 'style2',
                typeProfile: 'goals'
            }
        }
    ];
};

function PlayerH2HSeasonSMB({ params }) {
    return <SMStream smWidgets={smWidgets(params)} title="Team Stats" />;
}

PlayerH2HSeasonSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        playerId: PropTypes.string.isRequired
    }).isRequired
};

export default PlayerH2HSeasonSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/PlayerH2HSeasonSMB.js
 **/